import theme from '../Theme';

const styles = (materialTheme) => ({
  parentBoxDisplay: {
    height: '50px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '4px',
    border: '1px solid #7CD4FD',
    borderRadius: '8px',
    backgroundColor: '#F0F9FF',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  cardTextColor: {
    color: theme.colors.blue10,
    fontWeight: '500',
    marginLeft: '12px',
    [theme.screenSize.middleWidth]: {
      marginLeft: '24px',
    },
  },
  giftCardWidth: {
    width: '100%',
    marginTop: '20px',
    cursor: 'pointer',
    [theme.screenSize.middleWidth]: {
      margin: '0px 7px',
    },
  },
  parentBoxBorder: {
    width: '100%',
    [theme.screenSize.middleWidth]: {
      width: '91%',
      marginRight: '10px',
    },
  },
  balanceBox: {
    width: '100%',
  },
  balanceCheckBoxBorder: {
    border: '1px solid #D0D5DD',
    borderRadius: '8px',
    width: '100%',
    marginTop: '4px',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  balanceCheckbox: {
    color: theme.colors.blue500,
    marginLeft: '24px',
  },
  visaCardMargin: {
    marginLeft: '12px',
    [theme.screenSize.middleWidth]: {
      marginLeft: '24px',
    },
  },
  placeOrderButton: {
    width: '66%',
    marginTop: '24px',
    [theme.screenSize.middleWidth]: {
      width: '99%',
      background: '#FFFFFF',
      boxShadow: '0px -6px 12px 1px rgba(0, 0, 0, 0.08)',
      padding: '8px 8px 12px 8px',
    },
  },
  applyButton: {
    height: '59px',
    marginTop: '10px',
    borderRadius: '5px',
    width: '15%',
  },
  cardMargin: {
    marginTop: '12px',
    borderRadius: '0px',
    width: '85%',
  },
  giftCardInput: {
    borderRadius: '10px',
    marginLeft: '10px',
  },
  appliedGiftCard: {
    border: `1px solid ${materialTheme.palette.secondary.dark}`,
    padding: '12px 6px',
    background: theme.colors.white200,
    borderRadius: '10px',
    color: materialTheme.palette.primary.dark,
    margin: '10px 0px',
    display: 'flex',
    marginLeft: '6px',
    flexDirection: 'row',
  },
  appliedCardMargin: {
    [theme.screenSize.middleWidth]: {
      marginLeft: '15px',
    },
  },
  giftCode: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '24px',
    width: '100%',
  },
  redeemColor: {
    marginBottom: '4px',
  },
  gcCodeInputWidth: {
    display: 'flex',
  },
  gcCodeField: {
    height: '48px',
    marginTop: 'auto',
    borderRadius: '8px 0 0 8px',

    '&.MuiOutlinedInput-root.Mui-focused': {
      boxShadow: 'none',
      borderColor: theme.colors.success.main,
    },

    '& .MuiOutlinedInput-input': {
      fontSize: theme.font.size.sm,
      lineHeight: theme.font.lineHeight.sm,

      '&::placeholder': {
        fontWeight: theme.font.weight.medium,
        color: `${theme.colors.lightGray3} !important`,
        opacity: '.8 !important',
      },
    },
  },
  giftCodeSubmitBtn: {
    padding: '10px 16px',
    height: '48px',
    marginTop: 'auto',
    borderRadius: '0 8px 8px 0',
    transition: 'all 0s ease-in-out',

    '&.MuiButton-root.MuiButton-contained': {
      boxShadow: 'none',
    },
  },
});

export default styles;
